import getEnv from "@workspace/nextjs_utils/src/getEnv";

const getWebComponentGameHandles = (): string[] =>
  getEnv("WEB_COMPONENT_RENDERING_GAMES")?.split(",") ?? [];

export default getWebComponentGameHandles;
